import { Component } from '@angular/core'
import { NzDividerModule } from 'ng-zorro-antd/divider'
import { map } from 'rxjs'
import { AtomModule } from '../../atom/atom.module'
import { CollectionSlug } from '../../enums/collection.enums'
import { Order, ProductVariant } from '../../gql/generated'
import { NoItemsFoundComponent } from '../../molecule/no-items-found/no-items-found.component'
import { CartService } from '../../service/cart.service'
import { CollectionService } from '../../service/collection.service'
import { bestSellerStore } from '../../store/collection-stores'
import { CurrencyLocalePipe } from '../../utils/pipes/currency-locale.pipe'

@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html',
  styleUrl: './checkout.component.less',
  standalone: true,
  imports: [
    AtomModule,
    NzDividerModule,
    NoItemsFoundComponent,
    CurrencyLocalePipe,
  ],
})
export class CheckoutComponent {
  cartItems$ = this.cartService.cartStore$.pipe(
    map((state) => (state.activeOrder as Order)?.lines || [])
  )
  cartTotal$ = this.cartService.cartStore$.pipe(
    map((state) => (state.activeOrder as Order)?.total || 0)
  )
  cartItemsCount$ = this.cartService.getCartItemCount()

  SLUGS = CollectionSlug
  collection$ = bestSellerStore.pipe(
    map((state) => state.collection?.productVariants.items as ProductVariant[])
  )
  error$ = bestSellerStore.pipe(map((state) => state.error))

  constructor(
    private cartService: CartService,
    public collectionService: CollectionService
  ) {
    this.collectionService
      .fetchCollection(CollectionSlug.BEST_SELLER, 'pc')
      .subscribe()
  }

  increaseQuantity(cartItem) {
    if (!cartItem) return
    this.cartService
      .adjustCartQuantity(cartItem.id, cartItem.quantity + 1)
      .subscribe()
  }

  decreaseQuantity(cartItem) {
    if (cartItem.quantity === 1) return
    this.cartService
      .adjustCartQuantity(cartItem.id, cartItem.quantity - 1)
      .subscribe()
  }

  removeProduct(cartItem) {
    if (cartItem) {
      this.cartService.removeFromCart(cartItem.id).subscribe()
    }
  }
}
